import { map } from 'd3-collection';

const lookup = map();

const buildURL = path => `${process.env.PUBLIC_PATH}${path}`;

// gov race
lookup.set("Kamala Harris", buildURL('assets/images/harris.png'));

lookup.set('Donald J. Trump', buildURL('assets/images/trump.png'));

// ag race (just in case)

lookup.set('Ted Cruz', buildURL('assets/images/cruz.png'));

lookup.set('Colin Allred', buildURL('assets/images/allred.png'));

export { lookup };